export enum OrderTypes {
  Bagable = 'Bagable',
  NonPacking = 'NonPacking',
  MIXED = 'MIXED'
}
